import { render, staticRenderFns } from "./dormitoryTable.vue?vue&type=template&id=fe759f34&scoped=true"
import script from "./dormitoryTable.vue?vue&type=script&lang=js"
export * from "./dormitoryTable.vue?vue&type=script&lang=js"
import style0 from "./dormitoryTable.vue?vue&type=style&index=0&id=fe759f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe759f34",
  null
  
)

export default component.exports